var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCharityIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.582 4.424h0a5.02 5.02 0 011.631-1.168 4.697 4.697 0 011.906-.406c.652 0 1.3.137 1.906.406a5.021 5.021 0 011.631 1.168l.621-.58-.62.58a5.49 5.49 0 011.103 1.768c.257.665.39 1.38.39 2.102 0 .723-.133 1.437-.39 2.102a5.489 5.489 0 01-1.104 1.768h0l-.96 1.028h0l-7.244 7.753v.001a.622.622 0 01-.452.204.622.622 0 01-.452-.205l-7.244-7.753h0l-.96-1.028h0a5.489 5.489 0 01-1.104-1.768 5.828 5.828 0 01-.39-2.102c0-.723.133-1.437.39-2.102a5.49 5.49 0 011.104-1.768l-.621-.58.62.58a5.021 5.021 0 011.632-1.168A4.697 4.697 0 016.88 2.85c.652 0 1.3.137 1.906.406a5.02 5.02 0 011.631 1.168h0l.96 1.028.622.665.621-.665.96-1.028z",
    stroke: "#B9BBC6",
    strokeWidth: 1.7,
    strokeMiterlimit: 10
  })));
}
export default SvgCharityIcon;